import {
  MainnetLockingContract,
  PulseLockingContract,
  PulseTestLockingContract,
  TestLockingContract,
  TestMainWaitContract,
  TestWaitContract,
  WaitContract,
} from 'libs/data/contracts'
import { useAccount, useChainId } from 'wagmi'

import useRead, { ContractRead } from './useRead'

export default (): ContractRead<bigint> => {
  const validate = (value: unknown): value is bigint => typeof value === 'bigint'
  const account = useAccount()
  const chainId = useChainId()
  const addr =
    process.env.NEXT_PUBLIC_ENV == 'development' && chainId == 943
      ? PulseTestLockingContract.address
      : chainId == parseInt(process.env.NEXT_PUBLIC_ETH_CHAIN) && process.env.NEXT_PUBLIC_ENV == 'development'
        ? TestLockingContract.address
        : chainId == 1
          ? MainnetLockingContract.address
          : PulseLockingContract.address
  const abi =
    process.env.NEXT_PUBLIC_ENV == 'development' && chainId == 943
      ? PulseTestLockingContract.abi
      : chainId == parseInt(process.env.NEXT_PUBLIC_ETH_CHAIN) && process.env.NEXT_PUBLIC_ENV == 'development'
        ? TestLockingContract.abi
        : chainId == 1
          ? MainnetLockingContract.abi
          : PulseLockingContract.abi
  const waitAddress =
    process.env.NEXT_PUBLIC_ENV == 'development' && chainId == 943
      ? TestWaitContract.address
      : chainId == parseInt(process.env.NEXT_PUBLIC_ETH_CHAIN) && process.env.NEXT_PUBLIC_ENV == 'development'
        ? TestMainWaitContract.address
        : process.env.NEXT_PUBLIC_ENV != 'development'
          ? WaitContract.address
          : WaitContract.address

  // eslint-disable-next-line no-console
  //console.log('addr', addr)

  // eslint-disable-next-line no-console
  // console.log('abi', abi)

  // eslint-disable-next-line no-console
  // console.log('waitAddress', waitAddress)

  return useRead({
    contract: addr as `0x${string}`,
    abi: abi,
    functionName: 'locked',
    args: [account?.address, waitAddress],
    validate,
  })
}
